import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/services/api.service';
import {
	IIdentityBlockPayload,
	IIdentityDetailResponse,
	IIdentityListPayload,
	IIdentityListResponse,
	IPersonProcessFacesListPayload,
	IPersonProcessFacesListResponse,
	IPersonProcessIdentifiersListPayload,
	IPersonProcessIdentifiersListResponse,
	IPersonProcessDocumentsListPayload,
	IPersonProcessDocumentsListResponse,
	IPersonProcessIpsListPayload,
	IPersonProcessIpsListResponse,
} from '../models/identities.models';
import { IProcessUpdatePayload } from '../../processes/models/processes.models';

@Injectable({
	providedIn: 'root',
})
export class IdentitiesService extends ApiService {
	public list(body: IIdentityListPayload): Observable<IIdentityListResponse> {
		return this.http.post<IIdentityListResponse>(environment.apiUrl + `/persons`, body, {
			headers: this.getHeaders(),
		});
	}

	public detail(id: string): Observable<IIdentityDetailResponse> {
		return this.http.get<IIdentityDetailResponse>(environment.apiUrl + `/person/${id}`, {
			headers: this.getHeaders(),
		});
	}

	/** NIF-1047: actualiza Person (y OCR si el body trae operation_uuid). */
	public update(id: string, body: IProcessUpdatePayload): Observable<IIdentityDetailResponse> {
		return this.http.patch<IIdentityDetailResponse>(environment.apiUrl + `/person/${id}`, body, {
			headers: this.getHeaders(),
		});
	}

	public blockIdentity(body: IIdentityBlockPayload): Observable<void> {
		return this.http.post<void>(environment.apiUrl + `/person-blocked`, body, {
			headers: this.getHeaders(),
		});
	}

	public listPersonProcessIps(
		personUuid: string,
		body: IPersonProcessIpsListPayload,
	): Observable<IPersonProcessIpsListResponse> {
		return this.http.post<IPersonProcessIpsListResponse>(
			environment.apiUrl + `/person/${personUuid}/process-ips`,
			body,
			{ headers: this.getHeaders() },
		);
	}

	public listPersonProcessFaces(
		personUuid: string,
		body: IPersonProcessFacesListPayload,
	): Observable<IPersonProcessFacesListResponse> {
		return this.http.post<IPersonProcessFacesListResponse>(
			environment.apiUrl + `/person/${personUuid}/process-faces`,
			body,
			{ headers: this.getHeaders() },
		);
	}

	public listPersonProcessIdentifiers(
		personUuid: string,
		body: IPersonProcessIdentifiersListPayload,
	): Observable<IPersonProcessIdentifiersListResponse> {
		return this.http.post<IPersonProcessIdentifiersListResponse>(
			environment.apiUrl + `/person/${personUuid}/process-identifiers`,
			body,
			{ headers: this.getHeaders() },
		);
	}

	public listPersonProcessDocuments(
		personUuid: string,
		body: IPersonProcessDocumentsListPayload,
	): Observable<IPersonProcessDocumentsListResponse> {
		return this.http.post<IPersonProcessDocumentsListResponse>(
			environment.apiUrl + `/person/${personUuid}/process-documents`,
			body,
			{ headers: this.getHeaders() },
		);
	}
}
